<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="records" 
        :close-on-select="true"
        :reduce="val => val.id"
        placeholder="Category" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        label="title" 
        clearable 
        @search="fetchRecords"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch records</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>
    </div>
  </div>
</template>
  
<script>
  import { get } from 'lodash';

  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

  export default {
    components: {
      vSelect,
    },
    props: {
      value: {
        default: "",
        type: String,
        required: false,
      }
    },
    data() {
      return {
        loading: false,
        toggleModal: false,
  
        records: [],
        storeName: "labCategoryFrequencyStore",
      }
    },
    created() {
      if (this.value){
        this.fetchRecords(this.value, () => {});
      } else {
        this.records = this.getFrequencyStore(this.storeName)
      }
    },
    methods: {
      async fetchRecords(text, loadingMutator) {
        try {
          this.loading = true; 
          loadingMutator(true);
  
          const query = {
            page: 1,
            limit: 50,
            search: text || this.value,
          }
  
          const request = await this.useJwt().mainService.labCategories.list(query);
          const { data } = request.data;
          this.records = data;
        } catch (error) {
          const error_message = get(error, "response.data.message") || error.message
          console.log("error_message", error_message)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        } finally {
          this.loading = false;
          loadingMutator(false);
        }
      },
      onOptionSelected(val){
        this.$emit('change', val)

        const selected = this.records.find(record => record._id === val);
        if (selected) {
          this.updateFrequencyStore(this.storeName, selected);
        }
      },
    },
  }
</script>

